import React from 'react';
import { Leaf } from 'lucide-react';

const lineas = [
  {
    numero: 'Línea 1',
    titulo: 'Alimentación institucional',
    descripcion:
      'Supervisión técnica de casinos de personal y acompañamiento en cumplimiento normativo — para que la alimentación de tu organización esté respaldada por criterio profesional, no solo por costo.',
    imagen: '/linea-alimentacion.jpg',
    alt: 'Colaboradores sirviéndose comida en la línea de autoservicio de un casino de personal',
    sello: false,
  },
  {
    numero: 'Línea 2',
    titulo: 'Bienestar corporativo',
    descripcion:
      'Programas integrales adaptados a la realidad de cada organización:',
    detalles: [
      'Evaluaciones preventivas de salud (operativos, evaluaciones nutricionales, exámenes rápidos, detección de factores de riesgo).',
      'Charlas y talleres experienciales (alimentación saludable aplicada, manejo del estrés, alimentación consciente, salud digestiva).',
      'Diagnóstico organizacional, diseño de intervenciones, seguimiento y medición.',
    ],
    imagen: '/linea-bienestar.jpg',
    alt: 'Equipo de colaboradores compartiendo en una oficina luminosa',
    sello: false,
  },
  {
    numero: 'Línea 3',
    titulo: 'Nutrición, fitoterapia y aromaterapia',
    descripcion:
      'Nuestro sello distintivo: integración de plantas medicinales y aromaterapia en programas de bienestar, con actividades presenciales y online diseñadas específicamente para cada equipo.',
    imagen: '/linea-fitoterapia.jpg',
    alt: 'Manos preparando hierbas medicinales y flores secas en un mortero de piedra',
    sello: true,
  },
];

const Lineas = () => {
  return (
    <section id="lineas" className="section section-suave">
      <div className="container">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <h2 className="heading-2">
            Tres formas de trabajar el bienestar en{' '}
            <em>tu organización</em>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 items-stretch">
          {lineas.map((linea) => (
            <article
              key={linea.titulo}
              className={`linea-card${linea.sello ? ' linea-card--sello' : ''}`}
            >
              <div className="linea-card-imagen">
                <img
                  src={linea.imagen}
                  alt={linea.alt}
                  width="1920"
                  height="1080"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="linea-card-cuerpo">
                {linea.sello ? (
                  <span className="sello-badge">
                    <Leaf className="w-3.5 h-3.5" />
                    Nuestro sello
                  </span>
                ) : (
                  <span className="linea-numero">{linea.numero}</span>
                )}
                <h3 className="heading-3">{linea.titulo}</h3>
                <p className="body-medium">{linea.descripcion}</p>
                {linea.detalles && (
                  <ul className="lista-problema" style={{ gap: '0.625rem' }}>
                    {linea.detalles.map((detalle) => (
                      <li key={detalle} className="body-medium" style={{ fontSize: '0.9375rem' }}>
                        {detalle}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Lineas;
